import React from "react";
import { formatAddress } from "../../lib/Contact/util";
import { IListing, IListingSummary } from "../../lib/Listing";
import { IoBedOutline } from "react-icons/io5";
import { RiRuler2Line } from "react-icons/ri";
import { BiBath, BiMap } from "react-icons/bi";
import { MdPhotoSizeSelectLarge } from "react-icons/md";
import { IconContext } from "react-icons";
import { ListingVitals } from "./ListingVitals";
import { Button } from "../Button";

export interface IListingSummaryProps {
  listing: IListing;
  title?: string;
  showVitals?: boolean;
  className?: string;
  showFeatures?: boolean;
  showCourtesy?: boolean;
  showSourceMls?: boolean;
  callToAction?: { href: string; text?: string; }
}

export const ListingSummary: React.FC<IListingSummaryProps> = ({
  listing,
  className,
  title,
  showVitals = false,
  showFeatures = true,
  showCourtesy = true,
  showSourceMls = true,
  callToAction,
}) => {
  return (
    <div className={`listing-summary ${className}`}>
      {title && <h2 className="block">{title}</h2>}
      {showVitals && (
        <ListingVitals
          listing={listing}
          className="lg:float-right lg:ml-3 lg:mb-3"
        />
      )}
      {showFeatures && listing.features && listing.features.length > 0 && (
        <div className="flex flex-wrap justify-center listing-features gap-4 uppercase text-xl py-3">
          <span>Features:</span>
          {listing.features.map((value, index) => (
            <span key={index}>{value}</span>
          ))}
        </div>
      )}
      {listing.descriptionHTML && (
        <div
          className="leading-relaxed"
          dangerouslySetInnerHTML={{ __html: listing.descriptionHTML }}
        ></div>
      )}
      {!listing.descriptionHTML && listing.description && (
        <div
          className="text-justify md:text-left leading-relaxed m-4"
          dangerouslySetInnerHTML={{
            __html: listing.description.replace(/(?:\r\n|\r|\n)/g, "<br />"),
          }}
        ></div>
      )}
      {showCourtesy && listing.officeName && (
        <div className="flex flex-wrap listing-features gap-4 text-sm py-3 italic whitespace-pre-wrap">
          <span>Listing Courtesy of{"\n"}<span className="font-bold">{listing.officeName}</span></span>
        </div>
      )}
      {showSourceMls && listing.mlsSourceName && listing.mlsSourceLogoUrl && (
        <div className="flex flex-wrap justify-center listing-features gap-4 text-xs py-3 italic items-center">
          <span>Source <span className="font-bold">{listing.mlsSourceName}</span></span>
          <span><img src={listing.mlsSourceLogoUrl} alt="MLS Logo" style={{ height: "60px" }}></img></span>
        </div>
      )}
      {callToAction && (
        <Button
          linkProps={{
            href: callToAction.href,
            className: "mt-6",
          }}
        >
          {callToAction.text}
        </Button>
      )}
    </div>
  );
};
